import styled from 'styled-components';
import {Space} from 'antd';
import {bordersStyles, typographyStyles} from '../../../../../utils/styles';

const StyledBudgets = styled(Space)`
  ${bordersStyles.default};
  background-color: ${props => props.theme.colors.neutral_1};
  padding: 24px;
  width: 100%;

  & > .ant-space-item {
    width: 100%;
  }

  .has-actions-column {
    .actions-column-cell button {
      visibility: hidden;
    }
    .ant-btn-sm {
      &.ant-btn-icon-only {
        svg {
          height: 16px;
          width: 16px;
        }
        &:not(:hover) {
          svg {
            path {
              fill: ${props => props.theme.colors.neutral_7};
            }
          }
        }
      }
    }
  }

  /* Show the action button when hovering the row */
  .has-actions-column:hover {
    .actions-column-cell button {
      visibility: visible;  /* or opacity: 1 */
    }
  }

  .budgets-policies {
    border: none;

    .ant-card-body {
      padding: 0;
    }
  }
`;

const StyledBudgetsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  h5 {
    ${typographyStyles.heading.h5};
    margin: 0;
  }
`;

export {
  StyledBudgets,
  StyledBudgetsHeader,
}
